import { useCallback, useContext, useEffect } from 'react';
import { findByAlias } from '../../../routes';
import VehicleTypeService from '../../../services/vehicle-type-service/vehicle-type-service';
import ServerContext from '../../../contexts/serverContext';
import { useHistory, useParams } from 'react-router-dom';

export const useValidVin = () => {
    const { vin: queryVin } = useParams<{
        vin?: string;
    }>();

    const { currentLanguageRegionCode, current3LetterCountryCode } = useContext(
        ServerContext
    );
    const history = useHistory();

    const goToPageNotFound = useCallback(() => {
        const vinNotFoundPath = findByAlias('VehicleNotFoundView');
        const goToPath = `${vinNotFoundPath}?vin=${queryVin}`;
        history.push(goToPath);
    }, [queryVin, history]);

    const getVehicleAttributes = async (vinToCall: string) => {
        const typeService = new VehicleTypeService();

        return await typeService.vehicleType(
            vinToCall,
            currentLanguageRegionCode,
            current3LetterCountryCode?.toUpperCase()
        );
    };

    useEffect(() => {
        if (queryVin) {
            getVehicleAttributes(queryVin)
                .catch(() => goToPageNotFound())
                .finally();
        }
    }, [goToPageNotFound, queryVin]);
};
